<template>
    <div style="background: #f3f7f7;height: 100%;">

        <div class="login-wrap" v-show="isShow">
            <mt-header fixed title="欢迎使用云业务系统">
            </mt-header>

            <el-image class="img" :src="require('../../assets/img/img.png')">
            </el-image>

            <div class="viewBox">
                <el-button type="primary" @click="goWeightCloud()">
                    <el-image class="MLoginImg" :src="require('../../assets/img/cloudIndex.png')">
                    </el-image>
                    <p>云服务</p>
                </el-button>

                <el-button type="primary" @click="simpleBarcode()">
                    <el-image class="MLoginImg" :src="require('../../assets/img/barcodeIndex.png')">
                    </el-image>
                    <p>通用二维码</p>
                </el-button>

                <el-button type="primary" @click="goCompanyBarcode()">
                    <el-image class="MLoginImg" :src="require('../../assets/img/saoma.png')">
                    </el-image>
                    <p>扫码预约</p>
                </el-button>

                <el-button type="primary" @click="GoodsConfirm()">
                    <el-image class="MLoginImg" :src="require('../../assets/img/place.png')">
                    </el-image>
                    <p>装卸核验</p>
                </el-button>
            </div>


            <p @click="clickUse('new')"><a>使用新版</a></p>

        </div>

        <div class="login-wrap" v-show="isShow2">
            <mt-header fixed title="欢迎使用云业务系统">
            </mt-header>

            <el-image class="img2" :src="require('../../assets/img/banner_kunuocloud.png')">
            </el-image>

            <div class="viewBox2">

                <el-button type="primary" @click="goWeightCloud()">
                    <div class="imageBox">
                        <el-image class="MLoginImg" :src="require('../../assets/img/cloudIndex.png')">
                        </el-image>
                    </div>

                    <h3>云称重服务</h3>
                    <p>称重数据管理服务</p>
                </el-button>


                <el-button type="primary" @click="simpleBarcode()">
                    <div class="imageBox2">
                        <el-image class="MLoginImg" :src="require('../../assets/img/codeNew.png')">
                        </el-image>
                    </div>

                    <h3>通用二维码</h3>
                    <p>生成通用过磅二维码(公用)</p>
                </el-button>


                <el-button type="primary" @click="goCompanyBarcode()">
                    <div class="imageBox3">
                        <el-image class="MLoginImg" :src="require('../../assets/img/saoma2.png')">
                        </el-image>
                    </div>

                    <h3>二维码或预约</h3>
                    <p>支持过磅二维码或在线预约</p>
                </el-button>

                <el-button type="primary" @click="weighingReservation()">
                    <div class="imageBox2">
                        <el-image class="MLoginImg" :src="require('../../assets/img/codeNew.png')">
                        </el-image>
                    </div>

                    <h3>预约过磅服务</h3>
                    <p>新版预约过磅功能(VIP)</p>
                </el-button>

                <el-button type="primary" @click="GoodsConfirm()">
                    <div class="imageBox">
                        <el-image class="MLoginImg" :src="require('../../assets/img/place.png')">
                        </el-image>
                    </div>

                    <h3>装卸货核验</h3>
                    <p>装货/卸货核验功能</p>
                </el-button>

            </div>

            <p @click="clickUse('old')"><a>回到原版</a></p>

        </div>

    </div>

</template>
<script type="text/ecmascript-6">
export default {
    name: "mobileLogin",
    data() {
        return {
            isShow: false,
            isShow2: false,
        };
    },
    created() {
        // 页面加载时显示新旧页面 
        let val = this.$store.state.mobileLoginNewOrOld;

        if (val == 'new') {
            this.isShow2 = true;
            this.isShow = false;
        } else {
            this.isShow2 = false;
            this.isShow = true;
        }
    },
    methods: {
        goWeightCloud() {
            this.$router.push({
                path: "/companyLogin",
            });
        },

        simpleBarcode() {
            this.$router.push({
                path: "/simpleBarcode",
            });
        },
        goCompanyBarcode() {
            this.$router.push({
                path: "/barcodeLogin",
            });
        },

        GoodsConfirm() {
            this.$router.push({
                path: "/goodsLogin",
            });
        },
        weighingReservation() {
            this.$router.push({
                path: "/barcodeLoginNew",
            });
        },


        // 点击使用哪个界面 新或旧

        clickUse(val) {
            this.$store.commit("getMobileLoginNewOrOld", val);

            if (val == 'new') {
                this.isShow2 = true;
                this.isShow = false;
            } else {
                this.isShow2 = false;
                this.isShow = true;
            }
        },

    },
};
</script>

<style scoped lang="less">
.mint-header {
    background-color: #6495ED;
}

.login-wrap {
    text-align: center;
}

/deep/ .img {
    width: 150px;
    height: 150px;
    margin-top: 100px;
}

/deep/ .img2 {
    width: 70%;
    // height: 150px;
    margin-top: 80px;
}




.viewBox {
    width: 98%;
    margin: 10% auto;

    .el-button--primary {
        background-color: #6495ED;
        border-color: #6495ED;

        width: 40%;
        margin: 10px;


        /deep/ .el-image__inner {
            width: 70px;
            height: 70px;
        }
    }
}


.viewBox2 {
    width: 98%;
    margin: 10% auto;


    .el-button--primary {
        background-color: #ffffff;
        border-color: transparent;
        width: 90%;
        margin: 10px auto;
        display: block;
        border-radius: 15px;


        /deep/ .imageBox {
            width: 56px;
            height: 56px;
            background-color: #13227a;
            float: left;
            border-radius: 50%;
            text-align: center;
        }

        /deep/ .imageBox2 {
            width: 56px;
            height: 56px;
            background-color: #a00a55;
            float: left;
            border-radius: 50%;
            text-align: center;

        }

        /deep/ .imageBox3 {
            width: 56px;
            height: 56px;
            background-color: #f46606;
            float: left;
            border-radius: 50%;
            text-align: center;
        }



        /deep/ .el-image__inner {
            width: 33px;
            // height: 35px;
            display: block;
            margin: 0 auto;
            padding: 11px 0;
        }

        h3 {
            color: black;
            float: left;
            width: 70%;
            text-align: left;
            margin: 6px 10px;
            font-size: 22px;
        }

        p {
            float: left;
            color: gray;
            font-weight: 900;
            font-size: 14px;
            margin-left: 10px;

        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/login/mobileLogin.vue